import { Typography, useTheme } from '@mui/material';

interface StatusCellProps {
  content: any;
  suffix?: string;
}

const SuffixCell = ({ content, suffix }: StatusCellProps) => {
  const theme = useTheme();

  return (
    <Typography component="span" sx={{ fontSize: theme.custom.tableFontSizePx }}>
      {content}
      {suffix ? (
        <Typography
          component="span"
          sx={{
            color: theme.palette.grey[500],
            fontSize: theme.custom.tableFontSizePx,
          }}
        >
          {suffix}
        </Typography>
      ) : null}
    </Typography>
  );
};

export default SuffixCell;
